import React from "react";
import Footer from '../Global/Footer';
import Header from '../Global/Header';


function Forgot(){
    return(
        <>      
        <Header />      
<div className="container-fluid auth-bg">
    <div className="row">
    <h2 className='why-head heading'>Forgot Password? Reset Now!</h2>
        <div className="col-md-2">
        </div>
         <center>
        <div className="col-md-8">
        <form className="form-horizontal auth">        
                        <div className="form-group">
                            <label className="col-lg-3 control-label">Email:</label>
                            <div className="col-lg-8">
                            <input className="form-control" type="email" />
                            </div>
                        </div>
                        <div className="form-group">
                            <label className="col-md-3 control-label"> New Password:</label>
                            <div className="col-md-8">
                            <input className="form-control" type="password" />
                            </div>
                        </div>
                        <div className="form-group">
                            <label className="col-md-3 control-label">Confirm password:</label>
                            <div className="col-md-8">
                            <input className="form-control" type="password" />
                            </div>
                        </div>
                        <div className="form-group">
                            <label className="col-md-3 control-label"></label>
                            <div className="col-md-8 btn-block auth">
                            
                            <input type="button" className="custom-btn btn-banner" defaultValue="Save Changes" />
                            <span></span>
                            <input type="reset" className="custom-btn btn-banner second" defaultValue="Cancel" />
                            </div>
                        </div>
                        </form>
        </div>
        </center>
        <div className="col-md-2">    
        </div>  
</div>
</div>  
<Footer />
        </>
    )
}
export default Forgot;